import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'getBillingCycle' })
export class BillingCyclePipe implements PipeTransform {

    transform(value: number): string {

        if (!value) {
            return '';
        }

        switch ( value ) {
            case 1:
                return 'Monthly';
            case 2:
                return 'Yearly';

        }

    }

}
